import Fetch, { fetchConfig } from '@/hooks/fetch';
import actions from '../constants';

export default {
  useFetchDatasetAttachments: ({ category, code, exists }, readStatus) => Fetch.useFetchDispatch(
    actions.FETCH_DATASET_ATTACHMENTS,
    readStatus,
    { category, code },
    fetchConfig([readStatus], () => exists),
  ),
};
